export const navigateToFileProfile = (fileProfileId?: string) => {
  const url =
    fileProfileId === null
      ? `${process.env.REACT_APP_ENROLL_TRACK_PORTAL_URL}/fileprofile`
      : `${process.env.REACT_APP_ENROLL_TRACK_PORTAL_URL}/fileprofile/${fileProfileId}`;
  window.open(url, 'fileProfile');
};
export const navigateToFileHistory = (fileHistoryId?: string) => {
  const url =
    fileHistoryId === null
      ? `${process.env.REACT_APP_ENROLL_TRACK_PORTAL_URL}/fileprofile`
      : `${process.env.REACT_APP_ENROLL_TRACK_PORTAL_URL}/filehistorydetails/${fileHistoryId}`;
  window.open(url, 'fileHistory');
};
